
import React, { useContext } from 'react'
import styled, { ThemeContext } from 'styled-components'
import { Text } from 'rebass'

const ArtworkLevel = styled.div`
  display: flex;
  flex-direction: column;
  margin-bottom: 15px;
  width: auto;
  font-size: 14px;
  justify-content: space-between;
  flex-shrink: 1;
  flex-grow: 1;
  min-width: 95px;
  ${({ theme }) => theme.mediaWidth.upToInfoLarge`
    width: 50%;
    flex-grow: 0;
  `};
`

export default function InfoSolt ({artwork}: {artwork: any}) {
  const theme = useContext(ThemeContext)
  return (
    <>
      {
        <>
          <ArtworkLevel>
            <Text color={theme.bsText29}>Staking Power: </Text>
            <Text fontSize={16} color={theme.bsText14} fontFamily="Roboto-Bold" marginTop="6px">{artwork.stakingPower}</Text>
          </ArtworkLevel>
          <ArtworkLevel>
            <Text color={theme.bsText29}>PET to get when melt: </Text>
            <Text fontSize={16} color={theme.bsText14} fontFamily="Roboto-Bold" marginTop="6px">{artwork.petToGet}</Text>
          </ArtworkLevel>
          <ArtworkLevel>
            <Text color={theme.bsText29}>Bake to get when melt: </Text>
            <Text fontSize={16} color={theme.bsText14} fontFamily="Roboto-Bold" marginTop="6px">{artwork.bakeToGet}</Text>
          </ArtworkLevel>
          <ArtworkLevel>
            <Text color={theme.bsText29}>Battle Power increase: </Text>
            <Text fontSize={16} color={theme.bsText14} fontFamily="Roboto-Bold" marginTop="6px">{artwork.stakingPower}</Text>
          </ArtworkLevel>
        </>
      }
    </>
  )
}
